<template>
	<v-form ref="form" v-model="isFormValid" lazy-validation>
		<modal
			:exibir="exibir"
			titulo="Partes Envolvidas"
			:max-width="modalOptions.largura"
			:custom-actions="false"
			:acao-cancelar="fecharModal"
			:acao-confirmar="salvar"
			:is-confirmar-visivel="true"
			:is-confirmar-desabilitado="!isFormValid"
			nome-botao-confirmar="Salvar"
			@close="fecharModal"
		>
			<template #body>
				<v-row class="mt-1 mb-2">
					<v-col cols="12">
						<label-personalizado nome-campo="Órgão" obrigatorio-por-padrao></label-personalizado>
						<v-text-field
							id="nomeOrgao"
							v-model="formulario.nomeOrgao"
							placeholder="Informe o nome do órgão"
							maxlength="150"
							:rules="regrasNomeOrgao"
						></v-text-field>
					</v-col>
					<v-col cols="12">
						<label-personalizado nome-campo="CNPJ" obrigatorio-por-padrao></label-personalizado>
						<v-text-field
							id="cnpjParteEnvolvida"
							v-model="formulario.cnpj"
							v-input-mask="mascaraCnpj"
							placeholder="Informe o CNPJ"
							maxlength="18"
							:rules="regrasCnpj"
						></v-text-field>
					</v-col>
					<v-col cols="12">
						<label-personalizado
							nome-campo="Código da Unidade Compradora"
							obrigatorio-por-padrao
						></label-personalizado>
						<v-text-field
							id="codigoUnidadeCompradora"
							v-model.trim="formulario.codigoUnidadeCompradora"
							v-input-mask="mascaraSomenteNumeros"
							placeholder="Informe o código da unidade compradora"
							maxlength="30"
							:rules="regrasCodigoUnidadeCompradora"
						></v-text-field>
					</v-col>
				</v-row>
			</template>
		</modal>
	</v-form>
</template>

<script>
import Modal from '@/views/components/Modal.vue'
import LabelPersonalizado from '@/views/components/LabelPersonalizado.vue'
import validacaoFormulario from '@/views/mixins/validacaoFormulario'
import FormUtils from '@/core/utils/FormUtils'
import CNPJUtils from '@/core/utils/CNPJUtils'

export default {
	name: 'modal-adicionar-parte-envolvida',
	components: { LabelPersonalizado, Modal },
	mixins: [validacaoFormulario],
	props: {
		exibir: {
			type: Boolean,
		},
	},
	emits: ['fechar-modal', 'salvar'],
	data() {
		return {
			isFormValid: false,
			mascaraCnpj: { mask: '**.***.***/****-99' },
			mascaraSomenteNumeros: { regex: '\\d{0,30}' },
			modalOptions: {
				largura: '600',
			},
			formulario: {
				nomeOrgao: '',
				cnpj: '',
				codigoUnidadeCompradora: '',
			},
			regrasNomeOrgao: [(value) => this.regraObrigatoriedade(value, 'O campo é obrigatório.')],
			regrasCnpj: [
				(value) => this.regraObrigatoriedade(value, 'O campo é obrigatório.'),
				(value) => CNPJUtils.isValidCNPJ(value) || 'O CNPJ informado não é válido.',
			],
			regrasCodigoUnidadeCompradora: [(value) => this.regraObrigatoriedade(value, 'O campo é obrigatório.')],
		}
	},
	methods: {
		salvar() {
			if (!this.$refs.form.validate()) return

			this.$emit('salvar', this.montarPayload())
		},
		montarPayload() {
			return {
				nomeOrgao: this.formulario.nomeOrgao,
				cnpj: FormUtils.removerMascaraInput(this.formulario.cnpj),
				codigoUnidadeCompradora: this.formulario.codigoUnidadeCompradora,
			}
		},
		limparFormulario() {
			this.formulario = {
				nomeOrgao: '',
				cnpj: '',
				codigoUnidadeCompradora: '',
			}

			this.$refs.form.resetValidation()
		},
		fecharModal() {
			this.$emit('fechar-modal')
		},
	},
}
</script>
